export interface ContentFrontmatter {
  permalink: string;
}

export interface ContentModule<TFrontmatter extends ContentFrontmatter> {
  frontmatter: TFrontmatter;
}

export const normalizePermalink = (permalink: string): string => {
  if (!permalink || permalink === '/') {
    return permalink;
  }

  return permalink.endsWith('/') ? permalink : `${permalink}/`;
};

export const normalizeContentModules = <
  TFrontmatter extends ContentFrontmatter,
  TModule extends ContentModule<TFrontmatter>
>(
  modules: TModule[]
): TModule[] => {
  return modules.map((module) => ({
    ...module,
    frontmatter: {
      ...module.frontmatter,
      permalink: normalizePermalink(module.frontmatter.permalink)
    }
  }));
};

export const findContentByPathname = <
  TFrontmatter extends ContentFrontmatter,
  TModule extends ContentModule<TFrontmatter>
>(
  modules: TModule[],
  pathname: string
): TModule | undefined => {
  const normalized = normalizePermalink(pathname);
  return modules.find((module) => module.frontmatter.permalink === normalized);
};
